"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var Block = function Block(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "block"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.4775 0 0 4.4775 0 10C0 15.5225 4.4775 20 10 20C15.5225 20 20 15.5225 20 10C20 4.4775 15.5225 0 10 0ZM10 1.66C10.0008 1.66 10.0008 1.66 10.0017 1.66C12.0333 1.66 13.8933 2.39333 15.3325 3.61L15.32 3.6L3.6 15.32C2.39333 13.8933 1.66 12.0333 1.66 10.0017C1.66 10.0008 1.66 10.0008 1.66 10C1.66 5.39417 5.39417 1.66 10 1.66V1.66ZM10 18.34C9.99917 18.34 9.99833 18.34 9.9975 18.34C8.02083 18.34 6.20667 17.6458 4.785 16.4883L4.8 16.5L16.46 4.82C17.6167 6.21833 18.3233 8.025 18.34 9.99667V10C18.34 14.6058 14.6058 18.34 10 18.34V18.34Z"
  }));
};
var _default = exports["default"] = Block;